import type { IntlShape } from 'react-intl';
import EmptyFieldWarning from '../EmptyFieldWarning';

/**
 * The soft "recommended field is empty" hint, or nothing at all.
 *
 * Three record forms each carried their own `emptyWarn` closure around the same
 * component and the same message; the message is what makes it one hint.
 *
 * `bare` for a field inside an Autocomplete, whose own adornment container does
 * the positioning (see `mergeAutocompleteAdornment`).
 */
export function recommendedWarning(
    intl: IntlShape,
    isEmpty: boolean,
    bare = false
) {
    if (!isEmpty) {
        return undefined;
    }
    return (
        <EmptyFieldWarning
            bare={bare}
            message={intl.formatMessage({ id: 'common.recommendedEmpty' })}
        />
    );
}
